var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_1",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 595.28 841.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#_gradient_417);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke: #231815;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        fill: url(#_gradient_8);\n      }\n\n      .cls-3 {\n        fill: url(#_gradient_401);\n      }\n\n      .cls-3, .cls-4 {\n        stroke-width: 1.17px;\n      }\n\n      .cls-4 {\n        fill: url(#_gradient_401-2);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_gradient_417",
    "data-name": "gradient 417",
    x1: 279.17,
    y1: 280.58,
    x2: 388.17,
    y2: 280.58,
    gradientTransform: "translate(-57.24 95.64)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#070e28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27479c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_gradient_401",
    "data-name": "gradient 401",
    x1: 279.17,
    y1: 465.08,
    x2: 388.17,
    y2: 465.08,
    gradientTransform: "translate(73.22 41.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a17424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e243"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_gradient_8",
    "data-name": "gradient 8",
    x1: 231.92,
    y1: 340.49,
    x2: 340.92,
    y2: 340.49,
    gradientTransform: "translate(32.43 35.73)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c0204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e72922"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_gradient_401-2",
    "data-name": "gradient 401",
    x1: 231.92,
    y1: 524.99,
    x2: 340.92,
    y2: 524.99,
    gradientTransform: "translate(-98.03 -18.3)",
    xlinkHref: "#_gradient_401"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 221.92,
    y: 221.72,
    width: 109,
    height: 309,
    transform: "translate(-185.07 305.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 352.39,
    y: 476.68,
    width: 109,
    height: 60,
    transform: "translate(-239.11 436.12) rotate(-45)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 264.35,
    y: 221.72,
    width: 109,
    height: 309,
    transform: "translate(359.42 -115.27) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 133.89,
    y: 476.68,
    width: 109,
    height: 60,
    transform: "translate(413.46 15.19) rotate(45)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3ae17cb6aef3b509ce91e0aa11622237.svg";
export { ForwardRef as ReactComponent };